import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgTilesSmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.75 4C2.75 3.30964 3.30964 2.75 4 2.75L9 2.75C9.69036 2.75 10.25 3.30964 10.25 4V9C10.25 9.69036 9.69036 10.25 9 10.25H4C3.30964 10.25 2.75 9.69036 2.75 9L2.75 4ZM5.25 5.25L5.25 7.75L7.75 7.75L7.75 5.25L5.25 5.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.75 23.0012C2.75 22.3109 3.30964 21.7512 4 21.7512H9C9.69036 21.7512 10.25 22.3109 10.25 23.0012V28.0012C10.25 28.6916 9.69036 29.2512 9 29.2512H4C3.30964 29.2512 2.75 28.6916 2.75 28.0012L2.75 23.0012ZM5.25 24.2512V26.7512H7.75V24.2512H5.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.5 2.75C12.8096 2.75 12.25 3.30964 12.25 4L12.25 9C12.25 9.69036 12.8096 10.25 13.5 10.25L18.5 10.25C19.1904 10.25 19.75 9.69036 19.75 9V4C19.75 3.30964 19.1904 2.75 18.5 2.75L13.5 2.75ZM14.75 7.75V5.25H17.25V7.75L14.75 7.75Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.25 23.0012C12.25 22.3109 12.8096 21.7512 13.5 21.7512L18.5 21.7512C19.1904 21.7512 19.75 22.3109 19.75 23.0012V28.0012C19.75 28.6916 19.1904 29.2512 18.5 29.2512L13.5 29.2512C12.8096 29.2512 12.25 28.6916 12.25 28.0012V23.0012ZM14.75 24.2512V26.7512H17.25V24.2512H14.75Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M23 2.75C22.3096 2.75 21.75 3.30964 21.75 4V9C21.75 9.69036 22.3096 10.25 23 10.25H28C28.6904 10.25 29.25 9.69036 29.25 9V4C29.25 3.30964 28.6904 2.75 28 2.75L23 2.75ZM24.25 7.75V5.25H26.75V7.75H24.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21.75 23.0012C21.75 22.3109 22.3096 21.7512 23 21.7512H28C28.6904 21.7512 29.25 22.3109 29.25 23.0012V28.0012C29.25 28.6916 28.6904 29.2512 28 29.2512H23C22.3096 29.2512 21.75 28.6916 21.75 28.0012V23.0012ZM24.25 24.2512V26.7512H26.75V24.2512H24.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 12.25C3.30964 12.25 2.75 12.8096 2.75 13.5L2.75 18.5C2.75 19.1904 3.30964 19.75 4 19.75H9C9.69036 19.75 10.25 19.1904 10.25 18.5L10.25 13.5C10.25 12.8096 9.69036 12.25 9 12.25L4 12.25ZM5.25 17.25V14.75H7.75L7.75 17.25H5.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.25 13.5C12.25 12.8096 12.8096 12.25 13.5 12.25H18.5C19.1904 12.25 19.75 12.8096 19.75 13.5L19.75 18.5C19.75 19.1904 19.1904 19.75 18.5 19.75L13.5 19.75C12.8096 19.75 12.25 19.1904 12.25 18.5V13.5ZM14.75 14.75V17.25H17.25V14.75H14.75Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M23 12.25C22.3096 12.25 21.75 12.8096 21.75 13.5L21.75 18.5C21.75 19.1904 22.3096 19.75 23 19.75H28C28.6904 19.75 29.25 19.1904 29.25 18.5L29.25 13.5C29.25 12.8096 28.6904 12.25 28 12.25H23ZM24.25 17.25V14.75H26.75V17.25H24.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTilesSmall);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
